module.exports = {"pipeline":{"name":"pipeline-matrixScaleQuestion","title":"矩阵量表题","type":"qs-mark","only":"组件是否在页面只能有唯一一个，不如分享组件 //TODO"}}


//////////////////
// WEBPACK FOOTER
// ./components/pipeline-matrixScaleQuestion/package.json
// module id = 554
// module chunks = 2